import Order from "@/views/dashboard/models/Order";
import Role from "@/views/dashboard/models/Role";
export default {
  orders: 'الطلبات',
  filter_field: 'تصفية :',
  no_filter_selected: 'لم يتم تحديد اي تصفية',
  send_to_warehouse: 'أرسل إلى المستودع',
  export_orders: 'تحميل الطلبات',
  status_dialog: {
    title: 'تغيير حالة الطلب',
    text: 'هل أنت متأكد أنك تريد تغيير حالة الطلب إلى {type}'
  },
  bulk_edit_form: {
    order_status: {
      placeholder: 'إختر حالة الطلب',
      set_for_selected_orders: 'تعيين حالة {count} طلبات إلى',
      apply_button: 'تطبيق'
    },
    call_status: {
      placeholder: 'إختر حالة إتصال الطلب',
      set_for_selected_orders: 'تعيين حالة إتصال {count} طلبات إلى',
      apply_button: 'تطبيق'
    },
    order_call_agent: {
      placeholder: 'حدد وكيل الاتصال',
      set_for_selected_call_agents: 'تعيين وكيل إتصال ل {count} طلبات الى',
      apply_button: 'تطبيق'
    }
  },
  order_status: {
    placeholder: 'اختر حالة',
    set_for_selected_orders: 'تعيين حالة {count} من الطلبات إلى',
    apply_button: 'تطبيق'
  },
  order_call_agent: {
    placeholder: 'حدد وكيل الاتصال',
    set_for_selected_call_agents: 'تعيين وكيل الاتصال ل {count} طلبات الى',
    apply_button: 'تطبيق'
  },
  global_payment_statuses: {
    [Order.WAREHOUSE_PAID_STATUS]: 'المستودعات المدفوعة',
    [Order.SELLER_PAID_STATUS]: 'البائعين المدفوعين',
    [Order.WAREHOUSE_NOT_PAID_STATUS]: 'مستودعات غير مدفوعة',
    [Order.SELLER_NOT_PAID_STATUS]: 'الباعة غير المدفوعين'
  },
  sent_to_remote_system: {
    [Role.WAREHOUSE_ROLE]: 'المرسلات إلى المستودع',
    [Role.ADVERTISER_ROLE]: 'المرسلات إلى المعلن'
  },
  private_payment_statuses: {
    [Order.WAREHOUSE_PAID_STATUS]: 'مدفوع',
    [Order.SELLER_PAID_STATUS]: 'مدفوع',
    [Order.WAREHOUSE_NOT_PAID_STATUS]: 'غير مدفوع',
    [Order.SELLER_NOT_PAID_STATUS]: 'غير مدفوع'
  },
  filter: {
    search: {
      placeholder: 'البحث في الطلبات ...',
      display_name: 'البحث'
    },
    date: {
      placeholder: 'إختر تاريخا',
      display_name: 'التاريخ'
    },
    users: {
      option_all: 'جميع البائعين',
      display_name: 'البائع'
    },
    countries: {
      option_all: 'كل البلدان',
      display_name: 'البلد'
    },
    warehouses: {
      option_all: 'جميع المستودعات',
      display_name: 'المستودع'
    },
    call_agents: {
      option_all: 'جميع وكلاء الاتصال',
      display_name: 'وكيل الاتصال'
    },
    products: {
      option_all: 'جميع المنتجات',
      display_name: 'المنتج'
    },
    status: {
      display_name: 'الحالة'
    },
    payment: {
      display_name: 'أظهر فقط ل'
    },
    is_sent_to_remote_system: {
      display_name: 'أظهر فقط ل'
    },
    offer_type: {
      display_name: 'طريقة الدفع'
    }
  },
  order_form: {
    title: 'تفاصيل الطلب',
    subtitle: 'عرض أو تحديث تفاصيل الطلب',
    fields: {
      order_id: {
        title: 'رقم التعريف الخاص بالطلب'
      },
      page_link: {
        title: 'رايط صفحة البيع'
      },
      order_date: {
        title: 'تاريخ الطلب'
      },
      client_ip_address: {
        title: 'عنوان IP الزبون'
      },
      client_name: {
        title: 'اسم الزبون',
        placeholder: 'اكتب اسم الزبون'
      },
      client_email: {
        title: 'البريد الإلكتروني لالزبون'
      },
      client_phone: {
        title: 'رقم الهاتف',
        placeholder: 'اكتب رقم الهاتف'
      },
      payment_type: {
        title: 'طريقة الدفع'
      },
      payment_id: {
        title: 'معرف البيع'
      },
      client_country: {
        title: 'دولة الزبون'
      },
      country: {
        title: 'الدولة'
      },
      client_region: {
        title: 'المنطقة',
        placeholder: 'اختر المنطقة'
      },
      client_other_region: {
        title: 'منطقة أخرى',
        placeholder: 'اكتب منطقة أخرى'
      },
      client_city: {
        title: 'المدينة',
        placeholder: 'اختر مدينة'
      },
      client_other_city: {
        title: 'مدينة اخرى',
        placeholder: 'اكتب مدينة أخرى'
      },
      client_address: {
        title: 'عنوان التسليم',
        placeholder: 'اكتب عنوان التسليم'
      },
      client_zip_code: {
        title: 'الرمز بريدي',
        placeholder: 'اكتب الرمز البريدي'
      },
      main_offer: {
        title: 'العرض الرئيسي'
      },
      payout: {
        title: 'العمولة'
      },
      total_amount: {
        title: 'المبلغ الإجمالي'
      },
      total_amount_in_usd: {
        title: 'المبلغ الإجمالي بالدولار الأمريكي'
      },
      store_upsell: {
        title: 'تخزين Upsell'
      },
      call_upsell: {
        title: 'مكالمة Upsell'
      },
      total_amount_confirmed: {
        title: 'المبلغ الإجمالي المؤكد'
      },
      total_amount_confirmed_in_usd: {
        title: 'إجمالي المبلغ المؤكد بالدولار الأمريكي'
      },
      tracking_code: {
        title: 'رمز التتبع',
        placeholder: 'اكتب رمز التتبع'
      },
      tracking_link: {
        title: 'رابط التتبع',
        placeholder: 'اكتب رابط التتبع'
      },
      order_call_status: {
        title: 'حالة مكالمة الطلب',
        option: 'حدد حالة المكالمة'
      },
      order_call_comment: {
        title: 'تعليق مكالمة الطلب',
        placeholder: 'أدخل تعليقك هنا...'
      },
      order_call_shipping_notes: {
        title: 'ملاحظات الشحن',
        placeholder: 'أدخل ملاحظات الشحن الخاصة بك هنا ...'
      }
    },
    order_notes: {
      title: 'ملاحظات خاصة',
      subtitle: 'الملاحظات المحفوظة حول طلب العميل',
      table: {
        date: {
          title: 'التاريخ'
        },
        note: {
          title: 'الملاحظات'
        }
      },
      form: {
        content: {
          title: 'محتوى الملاحظة',
          placeholder: 'أضف ملاحظة جديدة هنا'
        },
        buttons: {
          add: 'أضف الملاحطات'
        }
      }
    },
    order_lines: {
      title: 'محتوى الطلب',
      subtitle: 'تفاصيل محتوى الطلب',
      table: {
        product_type: 'نوع المنتج',
        product: 'المنتج',
        sku: 'SKU',
        quantity: 'الكمية',
        confirmed_quantity: 'الكمية المؤكدة',
        price_and_currency: 'السعر والعملة',
        confirmed_price: 'السعر المؤكد'
      }
    },
    order_customer_call_history: {
      title: 'سجل مكالمات العملاء',
      subtitle: 'مكالمات العملاء التي أجراها وكيل الاتصال',
      table: {
        status: 'حالة',
        comment: 'تعليق',
        called_at: 'وقت الإتصال'
      },
      buttons: {
        add: 'إضافة تعليق'
      }
    },
    shipping_dialog: {
      title: 'معلومات الشحن'
    },
    buttons: {
      edit_order: 'تعديل الطلب',
      open_edit: 'تعديل الطلب',
      close_edit: 'إلغاء تعديل الطلب',
      no_answer_order: 'لم يتم الرد على الطلب',
      save_order: 'حفظ الطلب',
      cancel_order: 'الغاء الطلب',
      confirm_order: 'تأكيد الطلب',
      deliver_order: 'تسبيم الطلب',
      ship_order: 'شحن الطلب',
      return_order: 'اعادة الطلب',
      sent_to_warehouse: 'تحويل إلى المستودع',
      send_to_sheets: 'أرسل إلى Google Sheet'
    }
  },
  order_table: {
    actions: 'اجراءات',
    order_id: 'رقم التعريف الخاص بالطلب',
    date_and_time: 'التاريخ و الوقت',
    customer_name: 'الزبون',
    main_product: 'المنتج',
    phone_number: 'رقم الهاتف',
    total_items: 'مجموع العناصر',
    earnings: 'أرباح',
    order_seller: 'البائع',
    address: 'العنوان',
    total_amount: 'المبلغ الإجمالي',
    total_amount_confirmed: 'المبلغ الإجمالي المؤكد',
    total_in_usd: 'الإجمالي بالدولار الأمريكي',
    total_confirmed_in_usd: 'الإجمالي المؤكد بالدولار الأمريكي',
    payout: 'العمولة',
    offer_name: 'العرض',
    country: 'دولة',
    call_status: 'حالة المكالمة',
    sent_to_google_sheet: {
      title: 'تم الإرسال إلى Google Sheet ?',
      sent_to_all_google_sheets: 'تم إرسال الطلب إلى جميع جداول بيانات Google.',
      sent_only_to: 'يتم إرسال الطلب فقط إلى:',
      sent_to_none: 'لم يتم إرسال هذا الطلب إلى أي ورقة Google.'
    },
    call_comment: 'تعليق المكالمة',
    payment_status: 'حالة الدفع',
    status: 'حالة الطلب',
    tracking: 'تتبع',
    store_upsell: 'تخزين Upsell ؟',
    call_upsell: 'مكالمة Upsell ?',
    warehouse_paid: 'مدفوع للمستودع ?',
    seller_paid: 'مدفوع للبائع ?',
    payment: 'مدفوع',
    agent: 'وكيل',
    sent_to_warehouse: 'أرسات إلى المستودع ؟'
  }
};